import endpoints from "../data/endpoints";
import { RainfallResponse } from "../types/types";
import apiRequest from "./apiRequest";

export const fetchRainfall = async (
	lat: string,
	lon: string,
): Promise<RainfallResponse["data"]> => {
	const response = (await apiRequest(endpoints.rainfall.url, {
		method: endpoints.rainfall.requestMethod,
		body: JSON.stringify({ lat, lon }),
	})) as RainfallResponse;

	return response.data;
};
